export function kliknalPrzekierowanieDoKonfiguratora() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-ga-event-kliknal-przekierowanie-do-konfiguratora]');
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const position = target.getAttribute('data-ga-event-kliknal-przekierowanie-do-konfiguratora-position') || '';
        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;

        window.dataLayer.push({
            event: 'kliknal_przekierowanie_do_konfiguratora',
            subpage_url: currentUrl,
            position: position,
        });
    });
}
